export default {
  en: {
    Cancel: 'Cancel',
    Send: 'Send',
    doc_title_new_msg: 'New message',
    errors: {
      file_too_big: 'File is too big',
      general: 'General error'
    },
    form: {
      placeholder: 'Type your message…'
    },
    survey: {
      title: 'Hope your exchange went well',
      subtitle: 'Don\'t hesitate to rate ourselves'
    },
    uploads: {
      click: 'Click here to choose a file',
      drag: 'or drag it here'
    }
  },
  fr: {
    Cancel: 'Annuler',
    Send: 'Envoyer',
    doc_title_new_msg: 'Nouveau message',
    errors: {
      file_too_big: 'Le fichier est trop gros',
      general: 'Erreur générale'
    },
    form: {
      placeholder: 'Tapez votre message…'
    },
    survey: {
      title: 'Nous espérons que votre échange s\'est bien passé',
      subtitle: 'N\'hésitez pas à nous laisser votre avis'
    },
    uploads: {
      click: 'Cliquez ici pour choisir un fichier',
      drag: 'ou glissez-le ici'
    }
  }
}
